export const removeTimestamp = (name) => {
	return name.split('_').slice(1)?.join('_');
};
